import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('install_authentication_app_to_log_in'),
    description: defineMessage('when_you_want_to_log_in_port_articlesupportlink'),
    codeImageAlt: defineMessage('qr_code'),
    buttonCopy: defineMessage('copy_to_clipboard'),
    notificationCodeCopied: defineMessage('code_copied_to_clipboard'),
    errorStateIdEmpty: defineMessage('state_id_is_empty'),
    errorSetupCodeEmpty: defineMessage('setup_code_is_empty'),
};
